import { forwardRef, type HTMLAttributes } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/shared/utils/style.util";

const pillVariants = cva(
  [
    "inline-flex items-center gap-1.5",
    "rounded-atelier-pill",
    "font-medium",
    "whitespace-nowrap",
    "transition-colors duration-[120ms] ease-out",
  ].join(" "),
  {
    variants: {
      variant: {
        ink: "bg-atelier-ink-primary text-atelier-surface-raised",
        brand: "bg-atelier-brand-soft text-atelier-brand",
        muted: "bg-atelier-surface-muted text-atelier-ink-secondary",
        outlined: "border border-atelier-border text-atelier-ink-primary bg-transparent",
      },
      size: {
        sm: "h-6 px-2.5 text-[11px]",
        md: "h-7 px-3 text-xs",
        lg: "h-8 px-3.5 text-sm",
      },
    },
    defaultVariants: {
      variant: "muted",
      size: "md",
    },
  },
);

type PillVariantsProps = VariantProps<typeof pillVariants>;
type PillProps = HTMLAttributes<HTMLSpanElement> & PillVariantsProps;

const Pill = forwardRef<HTMLSpanElement, PillProps>(
  ({
    variant, size, className, ...props
  }, ref) => (
    <span
      ref={ref}
      className={cn(pillVariants({ variant, size }), className)}
      {...props}
    />
  ),
);

Pill.displayName = "Atelier.Pill";

export { Pill, pillVariants };
export type { PillProps, PillVariantsProps };
